import { MessageCircle } from 'lucide-react';

const WHATSAPP_LINK = 'https://wa.me/919028776813?text=Hi%2C%20I%20want%20to%20try%20ChestBuddy%20for%20my%20clinic';

export default function FloatingWhatsApp() {
  return (
    <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110">
      <MessageCircle className="w-7 h-7 text-white" />
    </a>
  );
}
